import { render } from "./AddPensionPage.vue?vue&type=template&id=07d684a6&scoped=true"
import script from "./AddPensionPage.vue?vue&type=script&lang=js"
export * from "./AddPensionPage.vue?vue&type=script&lang=js"

import "./AddPensionPage.vue?vue&type=style&index=0&id=07d684a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d684a6"]])

export default __exports__